var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditorRadioFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 6.667c3.043 0 5.511 2.387 5.511 5.333 0 2.945-2.468 5.333-5.511 5.333-3.044 0-5.512-2.387-5.512-5.333s2.468-5.333 5.512-5.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.667 2c1.43 0 2.773.262 4.03.786a10.472 10.472 0 013.28 2.138c.93.9 1.667 1.96 2.21 3.176A9.462 9.462 0 0122 12a9.461 9.461 0 01-.814 3.9 10.082 10.082 0 01-2.208 3.176c-.93.9-2.024 1.612-3.281 2.136-1.257.526-2.6.788-4.03.788-1.43 0-2.773-.262-4.03-.788a10.454 10.454 0 01-3.281-2.136c-.93-.9-1.667-1.96-2.209-3.176a9.462 9.462 0 01-.814-3.9c0-1.383.271-2.683.814-3.9a10.084 10.084 0 012.209-3.176 10.47 10.47 0 013.28-2.138A10.382 10.382 0 0111.667 2zm0 2c-2.308 0-4.263.776-5.865 2.326C4.201 7.876 3.4 9.766 3.4 12c0 2.233.8 4.125 2.402 5.674C7.404 19.224 9.36 20 11.667 20c2.308 0 4.263-.776 5.864-2.326 1.602-1.55 2.403-3.44 2.403-5.674 0-2.233-.801-4.125-2.403-5.674C15.93 4.776 13.975 4 11.667 4z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorRadioFill);
export default __webpack_public_path__ + "1825080af93638a3de3306ef3055526b.svg";
export { ForwardRef as ReactComponent };